module.exports = __webpack_public_path__ + "static/media/race-room.7048063f.png";